<template>
  <div>
    <div>
      <h2 class="text-center font-weight-light">
        Thống kê nông nghiệp
      </h2>
    </div>
    <div class="mt-4">
      <v-row>
        <v-col cols="12" md="6">
          <v-card outlined class="rounded-lg">
            <v-card-title>Doanh nghiệp theo khu vực</v-card-title>
            <v-card-text></v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card outlined class="rounded-lg">
            <v-card-title>Doanh nghiệp theo ngành hàng</v-card-title>
            <v-card-text></v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card outlined class="rounded-lg">
            <v-card-title>Sản phẩm nông nghiệp</v-card-title>
            <v-card-text></v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card outlined class="rounded-lg">
            <v-card-title>Lượt truy cập trong năm</v-card-title>
            <v-card-text 
              style="height: 300px; position: relative;">
              <v-skeleton-loader
                v-if="chartLoading"
                type="list-item-three-line, card-heading"
              />
              <SiteViewChart 
                :chart-data="chartData" 
                :height="1" 
                :width="2"
                @finish="onFinishRender" 
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
  import SiteViewChart from '@/components/public/reports/SiteViewChart';
  export default {
    components: {
      SiteViewChart
    },
    data: () => ({
      chartData: {},
      chartLoading: true,
    }),
    methods: {
      onFinishRender() {
        this.chartLoading = false;
      },
    }
  }
</script>